<template>
  <div class="ws-info">
    <div v-if="_displayCheck">
      <div
        v-if="_label"
        class="ws-info-label mb-2"
      >{{_label}}</div>
      <WsInfoText
        v-if="type=='text'||type=='password'||type=='email'||type=='textarea'||type=='number'"
        :hideOnNull="hideOnNull"
        :getText="getText"
        :value="value"
      ></WsInfoText>
      <WsInfoLink
        v-else-if="type=='link'"
        :value="value"
      ></WsInfoLink>
      <WsInfoLocales
        v-else-if="type=='locales'"
        :value="value"
        :fields="fields"
        :locale="locale"
        :hideOnNull="hideOnNull"
        :showLocalePicker="showLocalePicker"
      ></WsInfoLocales>
      <WsInfoDatetime
        v-else-if="type=='datetime'"
        :value="value"
      ></WsInfoDatetime>
      <WsInfoDate
        v-else-if="type=='date'"
        :value="value"
      ></WsInfoDate>
      <WsInfoFile
        v-else-if="type=='files'"
        :value="value"
      ></WsInfoFile>
      <WsInfoBelongsToFile
        v-else-if="type=='file'"
        :value="value"
      ></WsInfoBelongsToFile>
      <WsInfoBelongsTo
        v-else-if="type=='belongsTo'"
        :value="value"
        :textKey="textKey"
        :fields="fields"
        :modelName="modelName"
        :getText="getText"
        :relationPopup="relationPopup"
      ></WsInfoBelongsTo>
      <WsInfoHasMany
        v-else-if="type=='hasMany'"
        :value="value"
        :textKey="textKey"
        :fields="fields"
        :modelName="modelName"
        :getText="getText"
        :relationPopup="relationPopup"
      ></WsInfoHasMany>
      <WsInfoHtml
        v-else-if="type=='editor'"
        :value="value"
      ></WsInfoHtml>
      <WsInfoSwitch
        v-else-if="type=='switch'"
        :activeText="activeText"
        :inactiveText="inactiveText"
        :value="value"
      ></WsInfoSwitch>
      <WsInfoSelect
        v-else-if="type=='select'"
        :multiple="multiple"
        :items="items"
        :value="value"
      ></WsInfoSelect>
      <WsInfoSelect
        v-else-if="type=='multi-select'"
        :multiple="multiple"
        :items="items"
        :value="value"
      ></WsInfoSelect>
      <WsInfoRadio
        v-else-if="type=='radio'"
        :items="items"
        :value="value"
      ></WsInfoRadio>
      <WsInfoCheckbox
        v-else-if="type=='checkbox'"
        :items="items"
        :value="value"
      ></WsInfoCheckbox>
      <v-img
        v-else-if="type=='image'&&value"
        :max-width="maxWidth"
        :src="value"
      ></v-img>
      <WsInfoImages
        v-else-if="type=='images'"
        :max-width="maxWidth"
        :value="value"
      />
      <WsInfoColor
        v-else-if="type=='color'"
        :value="value"
      ></WsInfoColor>
      <WsInfoStringCompare
        v-else-if="type=='stringCompare'"
        :value="value"
      ></WsInfoStringCompare>
      <WsInfoActPicker
        v-else-if="type==='act-picker'"
        :originData="originData"
        :getText="getText"
        :value="value"
      ></WsInfoActPicker>
      <WsInfoMultiLayer
        v-else-if="type==='multi-layer'"
        :modelName="fields.modelName"
        :layersSetting="fields.layersSetting"
        :requiredField="fields.requiredField"
        :getUrl="fields.getUrl"
        :conditionKeys="fields.conditionKeys"
        :textKey="textKey"
        :valueKey="valueKey"
        :value="value"
        :originData="originData"
      ></WsInfoMultiLayer>
      <LvInfoOptionItem
        v-else-if="type==='optionItem'"
        :value="value"
      />
      <LvInfoOption
        v-else-if="type==='option'"
        :value="value"
      />
      <LvInfoNumericalComparisonConditionSetting
        v-else-if="type==='numericalComparisonConditionSetting'"
        :value="value"
      />
      <div v-else-if="type=='custom'">{{getValue(originData)}}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    _label() {
      if (this.displayLabel) {
        return this.label;
      } else {
        return null;
      }
    },
    _displayCheck() {
      if (this.displayCheck) {
        if (this.displayCheck(this.originData)) {
          return true;
        } else {
          return this.displayCheck(this.originData);
        }
      } else {
        return true;
      }
    },
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    hideOnNull: {
      type: Boolean,
      default: true,
    },
    displayLabel: {
      type: Boolean,
      default: true,
    },
    getText: {
      type: Function,
      default: null,
    },
    relationPopup: {
      type: Boolean,
      default: false,
    },
    showLocalePicker: {
      type: Boolean,
      default: false,
    },
    activeText: {
      type: String,
      default: "active",
    },
    inactiveText: {
      type: String,
      default: "inactive",
    },
    textKey: {
      type: String,
      default: "name",
    },
    valueKey: {
      type: String,
      default: "id",
    },
    locale: {
      type: String,
      default: null,
    },
    active: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    conditions: {
      type: Array,
      default: null,
    },
    maxWidth: {
      type: String,
      default: null,
    },
    fields: {
      type: Object,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    note: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    isOk: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    name: {
      type: [String, Array],
      default: null,
    },
    rules: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    parentState: {},
    parent: {
      type: String,
      default: null,
    },
    originData: {
      type: Object,
    },
    getValue: {
      type: Function,
    },
    displayCheck: {
      type: Function,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info.scss";
</style>